<template>
  <main class="flex flex-col flex-center h-100vh px-4">
    <slot></slot>
  </main>
</template>
